

export const frontMatter = {
	title: 'Introduction',
	sidebar_label: 'Introduction',
	sidebar_position: 0,
	description: 'Obtenez des instructions pas à pas sur la manière d\'utiliser des langages purs sur l\'API WebSocket de Deriv. Commencez à créer votre application de trading avec cet exemple d\'API.'
};
export const contentTitle = undefined;
export const metadata = {
  "id": "languages/intro",
  "title": "Introduction",
  "description": "Obtenez des instructions pas à pas sur la manière d'utiliser des langages purs sur l'API WebSocket de Deriv. Commencez à créer votre application de trading avec cet exemple d'API.",
  "source": "@site/i18n/fr/docusaurus-plugin-content-docs/current/languages/intro.md",
  "sourceDirName": "languages",
  "slug": "/languages/intro",
  "permalink": "/fr/docs/languages/intro",
  "draft": false,
  "unlisted": false,
  "tags": [],
  "version": "current",
  "lastUpdatedAt": 1748500809000,
  "sidebarPosition": 0,
  "frontMatter": {
    "title": "Introduction",
    "sidebar_label": "Introduction",
    "sidebar_position": 0,
    "description": "Obtenez des instructions pas à pas sur la manière d'utiliser des langages purs sur l'API WebSocket de Deriv. Commencez à créer votre application de trading avec cet exemple d'API."
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "Languages",
    "permalink": "/fr/docs/category/languages"
  },
  "next": {
    "title": "JavaScript",
    "permalink": "/fr/docs/category/javascript"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    admonition: "admonition",
    code: "code",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Chaque section de langue contient des instructions pas à pas sur la façon d'utiliser les ", _jsx(_components.code, {
        children: "Deriv WebSocket Server APIs"
      }), " avec les caractéristiques de la langue. Si vous utilisez donc nos documents pour la première fois, veuillez parcourir chaque section afin d'en tirer le meilleur parti."]
    }), "\n", _jsx(_components.admonition, {
      type: "tip",
      children: _jsx(_components.p, {
        children: "Vous pouvez accéder directement à n'importe quelle section. Des liens vers les exigences vous aident à mieux démarrer chaque étape."
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

